// LM Audit d'acquisition — paragraphe 2.2 « Nature et objectif de la
// mission » : 19 titres et leurs lignes (liste fournie par Anthony HOARAU).
// Tout est coché par défaut ; l'utilisateur décoche au cas par cas. Seules
// les lignes décochées sont mémorisées (formData.audit_lignes_exclues, clés
// "titre.ligne", ex. "3.4"), pour que toute ligne ajoutée plus tard ici soit
// cochée d'office dans les brouillons existants.

export const AUDIT_AXES = [
  {
    titre: "Prise de connaissance de l’entreprise et du projet d’acquisition",
    lignes: [
      "Prise de connaissance de l’activité, de l’historique, de l’organisation et du modèle économique de la cible.",
      "Identification des sociétés, établissements, fonds de commerce et actifs compris dans le périmètre de l’opération.",
      "Analyse de l’organigramme juridique, de la répartition du capital et des relations entre les entités.",
      "Prise de connaissance des objectifs du repreneur et des modalités envisagées de l’acquisition.",
      "Examen de la lettre d’intention, des offres et des accords préalables communiqués.",
      "Identification des modalités envisagées de détermination et de règlement du prix.",
      "Prise de connaissance des rapports d’évaluation, d’audit ou de conseil déjà établis.",
      "Entretiens avec les dirigeants, les responsables opérationnels et les conseils de la cible.",
      "Identification des informations manquantes et des investigations complémentaires nécessaires.",
    ],
  },
  {
    titre: "Analyse de l’information comptable et financière",
    lignes: [
      "Examen des comptes annuels et de leurs annexes sur les exercices retenus.",
      "Examen des situations comptables intermédiaires et des tableaux de bord disponibles.",
      "Prise de connaissance des rapports du commissaire aux comptes et des observations de l’expert-comptable.",
      "Analyse des méthodes comptables et de leurs changements au cours des périodes examinées.",
      "Rapprochement des comptes annuels avec les balances générales et les états de gestion.",
      "Analyse des écritures de clôture et des opérations inhabituelles ou significatives.",
      "Examen ciblé du rattachement des charges et des produits aux exercices concernés.",
      "Analyse des comptes d’attente, des comptes transitoires et des soldes anciens ou inhabituels.",
      "Appréciation de la qualité et des limites de l’information financière disponible.",
      "Identification des retraitements nécessaires à la comparaison des exercices.",
    ],
  },
  {
    titre: "Analyse de l’activité et du chiffre d’affaires",
    lignes: [
      "Analyse de l’évolution du chiffre d’affaires sur les périodes examinées.",
      "Ventilation de l’activité par société, établissement, magasin, produit, service ou canal de distribution.",
      "Analyse de la saisonnalité et des variations mensuelles de l’activité.",
      "Analyse des effets de prix, de volume et de composition des ventes, selon les données disponibles.",
      "Analyse de la concentration du chiffre d’affaires et de la dépendance aux principaux clients.",
      "Examen du caractère récurrent des revenus et des conditions de renouvellement des contrats.",
      "Analyse des remises, ristournes, avoirs, retours et annulations de ventes.",
      "Examen des indicateurs commerciaux disponibles : fréquentation, panier moyen, taux de transformation ou récurrence des achats.",
      "Analyse du carnet de commandes et des perspectives commerciales documentées.",
      "Identification des ventes exceptionnelles, intragroupe ou réalisées avec des parties liées.",
      "Analyse de l’évolution récente de l’activité depuis la dernière clôture.",
    ],
  },
  {
    titre: "Analyse des marges et de la rentabilité",
    lignes: [
      "Analyse de l’évolution de la marge commerciale, de la valeur ajoutée et des principaux résultats intermédiaires.",
      "Analyse des marges par activité, établissement, famille de produits ou catégorie de clients.",
      "Examen des méthodes de calcul des marges et des clés de répartition des charges communes.",
      "Analyse des achats, des coûts d’approvisionnement, du transport et des frais accessoires.",
      "Analyse des charges fixes, des charges variables et du levier d’exploitation.",
      "Analyse des charges de personnel, des rémunérations des dirigeants et des avantages associés.",
      "Identification des produits et charges exceptionnels, non récurrents ou étrangers à l’exploitation normale.",
      "Analyse des transactions avec les dirigeants et les parties liées et de leurs conditions économiques.",
      "Proposition de retraitements pour déterminer une rentabilité historique normalisée.",
      "Analyse du seuil de rentabilité et de la sensibilité du résultat aux principales variables d’exploitation.",
      "Identification des activités ou établissements déficitaires.",
      "Appréciation des économies, synergies ou améliorations de marge envisagées par le repreneur, en distinguant celles-ci de la performance historique de la cible.",
    ],
  },
  {
    titre: "Analyse des immobilisations et des investissements",
    lignes: [
      "Examen de la composition et de l’ancienneté des immobilisations.",
      "Rapprochement du fichier des immobilisations avec les données comptables.",
      "Examen documentaire de la propriété des principaux actifs et des restrictions qui les affectent.",
      "Analyse des amortissements, dépréciations et valeurs nettes comptables.",
      "Identification des actifs inutilisés, obsolètes ou non nécessaires à l’exploitation.",
      "Analyse des investissements historiques et des engagements d’investissement.",
      "Identification des besoins de renouvellement, de maintenance et de mise aux normes signalés.",
      "Distinction entre investissements de maintien de l’activité et investissements de développement.",
      "Analyse des contrats de crédit-bail et de location-financement.",
      "Identification des actifs appartenant aux dirigeants ou à des tiers et nécessaires à la poursuite de l’activité.",
    ],
  },
  {
    titre: "Analyse des stocks et des en-cours",
    lignes: [
      "Analyse de la composition des stocks par catégorie, établissement et ancienneté.",
      "Examen des procédures d’inventaire et des derniers résultats d’inventaire disponibles.",
      "Rapprochement des états de stocks avec la comptabilité.",
      "Analyse des méthodes de valorisation et des coûts incorporés.",
      "Analyse de la rotation des stocks et de leur évolution.",
      "Identification des stocks dormants, obsolètes, détériorés ou difficilement commercialisables.",
      "Analyse des dépréciations constatées et estimation des ajustements éventuels.",
      "Examen des stocks en transit, en dépôt, en consignation ou détenus pour le compte de tiers.",
      "Analyse des clauses de réserve de propriété affectant les stocks.",
      "Examen de la valorisation des en-cours de production et des travaux en cours.",
      "Observation physique ciblée des stocks, si expressément prévue dans la mission.",
      "Analyse des modalités de reprise et de valorisation des stocks dans le prix de cession.",
    ],
  },
  {
    titre: "Analyse des créances clients et des autres créances",
    lignes: [
      "Analyse des balances âgées et des délais de règlement.",
      "Examen des encaissements intervenus après la date d’analyse.",
      "Identification des créances anciennes, litigieuses, douteuses ou irrécouvrables.",
      "Analyse des dépréciations et proposition d’ajustements éventuels.",
      "Examen des avoirs à établir, remises à accorder et retours attendus.",
      "Analyse des avances et acomptes versés aux fournisseurs.",
      "Examen des créances fiscales, sociales et diverses.",
      "Analyse des comptes courants débiteurs et des créances sur les parties liées.",
      "Examen des créances cédées, mobilisées ou remises en garantie.",
      "Identification des concentrations de risque de crédit.",
    ],
  },
  {
    titre: "Analyse des dettes et des passifs",
    lignes: [
      "Analyse des dettes fournisseurs et de leur ancienneté.",
      "Identification des retards de paiement, litiges et échéanciers négociés.",
      "Examen ciblé des charges à payer et des factures non parvenues.",
      "Analyse des avances et acomptes reçus des clients.",
      "Analyse des produits constatés d’avance et des prestations restant à exécuter.",
      "Examen des avoirs, cartes cadeaux, bons d’achat et engagements de fidélité restant à honorer.",
      "Analyse des provisions pour risques et charges.",
      "Examen des dettes envers les dirigeants, associés et autres parties liées.",
      "Identification des passifs potentiels ressortant des documents et entretiens.",
      "Examen ciblé des paiements et factures postérieurs à la clôture afin d’identifier d’éventuels passifs non enregistrés.",
    ],
  },
  {
    titre: "Analyse de la trésorerie et de l’endettement financier",
    lignes: [
      "Analyse des disponibilités et des rapprochements bancaires.",
      "Identification de la trésorerie indisponible, affectée ou soumise à restriction.",
      "Analyse des emprunts, concours bancaires et échéanciers de remboursement.",
      "Examen des taux, garanties, sûretés et clauses financières des financements.",
      "Identification des clauses de changement de contrôle et d’exigibilité anticipée.",
      "Analyse des comptes courants d’associés et de leurs conditions de remboursement.",
      "Analyse des engagements de crédit-bail, d’affacturage et des autres financements.",
      "Identification des engagements assimilables à de la dette dans le cadre de l’opération.",
      "Détermination d’un endettement net ajusté selon une définition convenue.",
      "Analyse de la capacité de remboursement et des tensions de trésorerie.",
      "Examen des incidents bancaires, moratoires et mesures de restructuration financière.",
    ],
  },
  {
    titre: "Analyse du besoin en fonds de roulement et des flux de trésorerie",
    lignes: [
      "Analyse de l’évolution historique et mensuelle du besoin en fonds de roulement.",
      "Analyse des délais clients, fournisseurs et de rotation des stocks.",
      "Identification des variations saisonnières et des besoins de financement de pointe.",
      "Identification des éléments exceptionnels affectant le besoin en fonds de roulement.",
      "Estimation d’un besoin en fonds de roulement normalisé.",
      "Analyse de la conversion des résultats en trésorerie.",
      "Reconstitution ou analyse des flux de trésorerie d’exploitation, d’investissement et de financement.",
      "Analyse des effets des retards de paiement fiscaux, sociaux ou fournisseurs sur la trésorerie apparente.",
      "Estimation du besoin de trésorerie à la reprise.",
      "Analyse de l’incidence d’une évolution de l’activité sur le financement de l’exploitation.",
    ],
  },
  {
    titre: "Analyse ciblée de la situation fiscale",
    lignes: [
      "Prise de connaissance des régimes fiscaux applicables et des principales obligations déclaratives.",
      "Rapprochement ciblé des déclarations fiscales avec les données comptables.",
      "Analyse des dettes et créances fiscales et de leur justification.",
      "Examen ciblé de la TVA collectée, déductible, à régulariser et des crédits de TVA.",
      "Analyse des retards déclaratifs, arriérés et échéanciers fiscaux.",
      "Examen du traitement fiscal des opérations significatives ou inhabituelles.",
      "Analyse des déficits reportables, crédits d’impôt et autres avantages fiscaux.",
      "Examen des conditions de maintien des avantages fiscaux après l’opération.",
      "Analyse des taxes spécifiques à l’activité ou à son implantation, notamment de l’octroi de mer lorsqu’il est pertinent.",
      "Prise de connaissance des contrôles fiscaux, propositions de rectification, contentieux et rescrits communiqués.",
      "Identification et estimation, lorsque possible, des risques fiscaux ressortant des travaux.",
      "Analyse des conséquences fiscales des modalités d’acquisition envisagées.",
    ],
  },
  {
    titre: "Analyse ciblée de la situation sociale",
    lignes: [
      "Analyse des effectifs, de leur répartition et de leur évolution.",
      "Analyse de la masse salariale et des coûts de personnel par activité ou établissement.",
      "Examen ciblé des contrats de travail, rémunérations variables et avantages particuliers.",
      "Analyse des engagements envers les dirigeants et les salariés clés.",
      "Examen des dettes sociales, retards de paiement et échéanciers.",
      "Analyse des provisions pour congés payés, primes, indemnités et engagements de retraite.",
      "Prise de connaissance des accords collectifs et dispositifs d’intéressement ou de participation.",
      "Examen des contrôles sociaux, contentieux et réclamations communiqués.",
      "Identification des dépendances à certains salariés ou dirigeants.",
      "Estimation des conséquences financières des recrutements, départs ou réorganisations envisagés.",
      "Analyse des incidences sociales de l’opération, en coordination avec les conseils spécialisés.",
    ],
  },
  {
    titre: "Analyse documentaire juridique et contractuelle",
    lignes: [
      "Examen des statuts, de la répartition du capital et des principaux actes sociaux communiqués.",
      "Identification des restrictions à la cession, agréments et droits particuliers.",
      "Examen des principaux contrats clients, fournisseurs, distributeurs et partenaires.",
      "Identification des clauses de changement de contrôle, de résiliation, d’exclusivité ou de non-concurrence.",
      "Analyse des engagements minimums d’achat ou de vente et des pénalités contractuelles.",
      "Examen des baux commerciaux : durée, loyers, indexations, charges, renouvellement et conditions de cession.",
      "Identification des dépôts de garantie, cautions, nantissements et autres sûretés.",
      "Examen documentaire des droits sur l’enseigne, les marques, noms de domaine et autres actifs incorporels.",
      "Prise de connaissance des contrats de franchise, licences et autorisations nécessaires à l’activité.",
      "Analyse des conventions entre les sociétés du groupe, les dirigeants et les associés.",
      "Prise de connaissance des litiges, procédures et engagements hors bilan communiqués.",
      "Identification des sujets nécessitant l’intervention d’un avocat ou d’un autre spécialiste.",
    ],
  },
  {
    titre: "Analyse des dépendances opérationnelles et des conditions de reprise",
    lignes: [
      "Identification des dépendances envers les fournisseurs, clients, bailleurs et partenaires essentiels.",
      "Analyse des conditions d’approvisionnement et des possibilités de substitution.",
      "Identification des fonctions exercées personnellement par le cédant et des conditions de leur transfert.",
      "Analyse des prestations et moyens partagés avec des entités non reprises.",
      "Estimation des coûts nécessaires pour rendre autonome le périmètre acquis.",
      "Analyse des besoins d’accompagnement et de transition après la cession.",
      "Prise de connaissance des outils de gestion, logiciels et contrats informatiques essentiels.",
      "Identification des risques opérationnels signalés et de leurs incidences financières potentielles.",
      "Prise de connaissance des assurances et des sinistres significatifs déclarés.",
      "Identification des besoins d’expertises techniques, réglementaires ou environnementales complémentaires.",
    ],
  },
  {
    titre: "Analyse des prévisions et de la faisabilité financière",
    lignes: [
      "Examen critique des hypothèses du prévisionnel communiqué.",
      "Rapprochement des hypothèses prévisionnelles avec les performances historiques et les informations récentes.",
      "Analyse des perspectives de chiffre d’affaires, de marges et de charges.",
      "Intégration des investissements, besoins en fonds de roulement et coûts de reprise.",
      "Élaboration ou adaptation d’un prévisionnel d’exploitation et de trésorerie.",
      "Construction de scénarios et réalisation d’analyses de sensibilité.",
      "Estimation du financement global nécessaire à l’opération.",
      "Analyse de la capacité de remboursement de la cible et, le cas échéant, de la holding d’acquisition.",
      "Analyse de la capacité de distribution de la cible au regard des besoins de la holding.",
      "Appréciation de la faisabilité financière du projet selon les hypothèses retenues.",
    ],
  },
  {
    titre: "Évaluation et appréciation du prix d’acquisition",
    lignes: [
      "Analyse critique du rapport d’évaluation transmis et des méthodes utilisées.",
      "Examen de la pertinence des hypothèses, agrégats et retraitements retenus.",
      "Détermination d’indicateurs financiers normalisés utiles à l’évaluation.",
      "Mise en œuvre de méthodes d’évaluation adaptées à l’entreprise et aux données disponibles.",
      "Estimation d’une fourchette de valeur et analyse de sa sensibilité aux principales hypothèses.",
      "Distinction entre valeur d’entreprise et valeur des titres.",
      "Passage de la valeur d’entreprise à la valeur des titres à partir de l’endettement net et des autres ajustements retenus.",
      "Analyse des actifs hors exploitation et des passifs spécifiques.",
      "Analyse de la cohérence du prix demandé avec la rentabilité, le patrimoine et les perspectives de la cible.",
      "Analyse du traitement des stocks, comptes courants et autres éléments inclus ou exclus du prix.",
      "Appréciation de l’incidence financière des risques identifiés sur la valeur.",
      "Préparation d’un argumentaire financier destiné à la négociation du prix.",
    ],
  },
  {
    titre: "Structuration financière et assistance à la négociation",
    lignes: [
      "Comparaison des modalités d’acquisition envisagées : titres, fonds de commerce ou actifs.",
      "Analyse des conséquences financières et fiscales des différents schémas.",
      "Assistance à la construction d’une offre de reprise chiffrée.",
      "Analyse des modalités de paiement : paiement comptant, crédit-vendeur, paiement différé ou complément de prix.",
      "Simulation de mécanismes de complément de prix et de leurs effets financiers.",
      "Assistance à la définition des agrégats utilisés dans les clauses de prix.",
      "Proposition de mécanismes d’ajustement fondés sur l’endettement net, la trésorerie ou le besoin en fonds de roulement.",
      "Identification des risques à prendre en compte dans les garanties et protections contractuelles.",
      "Participation aux réunions de négociation sur les aspects comptables et financiers.",
      "Coordination avec les conseils juridiques et les établissements financeurs, dans les limites de la mission convenue.",
    ],
  },
  {
    titre: "Actualisation et travaux à la réalisation de l’opération",
    lignes: [
      "Actualisation des analyses à partir des informations disponibles avant la réalisation de l’acquisition.",
      "Examen des événements intervenus depuis les derniers comptes analysés.",
      "Analyse des distributions, prélèvements et opérations avec les parties liées intervenus avant la cession.",
      "Examen du respect des engagements financiers convenus pour la période précédant la réalisation.",
      "Assistance à la définition des règles d’établissement des comptes de cession.",
      "Analyse des comptes de cession et des calculs d’ajustement du prix.",
      "Assistance à la détermination du prix définitif.",
      "Assistance à l’analyse des désaccords comptables et financiers relatifs aux ajustements de prix.",
    ],
  },
  {
    titre: "Restitution et recommandations",
    lignes: [
      "Établissement d’une synthèse des travaux réalisés et des informations examinées.",
      "Présentation des limitations rencontrées et des informations non obtenues.",
      "Hiérarchisation des risques et points de vigilance identifiés.",
      "Présentation des ajustements proposés et de leurs incidences chiffrées, lorsque celles-ci peuvent être estimées.",
      "Distinction entre les éléments documentés, les estimations et les hypothèses restant à confirmer.",
      "Identification des conditions à satisfaire et des investigations à mener avant l’acquisition.",
      "Formulation de recommandations sur le prix, le financement et les conditions économiques de l’opération.",
      "Présentation des actions prioritaires à engager après la reprise.",
      "Remise d’un rapport d’analyse et de recommandations sans expression d’assurance.",
      "Réunion de restitution et échanges avec le client et les conseils autorisés.",
    ],
  },
];

export const cleLigne = (iAxe, iLigne) => `${iAxe + 1}.${iLigne + 1}`;

// formData.audit_lignes_exclues : tableau (formulaire) ou JSON (brouillon).
export function lignesExclues(valeur) {
  if (Array.isArray(valeur)) return valeur;
  if (typeof valeur === "string" && valeur.trim().startsWith("[")) {
    try {
      const v = JSON.parse(valeur);
      return Array.isArray(v) ? v : [];
    } catch {
      return [];
    }
  }
  return [];
}

// Données du paragraphe 2.2 pour le modèle Word ({#axes}{numero}. {titre}
// {#lignes}- {texte} ;{/lignes}{/axes}). Un titre dont toutes les lignes sont
// décochées disparaît, et les titres suivants sont renumérotés.
export function axesPourDocument(exclues) {
  const set = new Set(lignesExclues(exclues));
  return AUDIT_AXES.map((axe, i) => ({
    titre: axe.titre,
    lignes: axe.lignes
      .map((texte, j) => ({ texte: texte.replace(/\.$/, ""), cle: cleLigne(i, j) }))
      .filter((l) => !set.has(l.cle))
      .map(({ texte }) => ({ texte })),
  }))
    .filter((axe) => axe.lignes.length > 0)
    .map((axe, i) => ({ ...axe, numero: i + 1 }));
}
